import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Link from 'components/link'
import { helloBabyPostPath } from 'lib/urls'
import PostCard from '../post-card'
import PostCardRow from '../post-card-row'

import * as css from './topic-section.scss'
import { StyledSubHeading } from '../../../components/headings'

class TopicSection extends Component {
  static defaultProps = {
    numOfSupportingPosts: 2,
    showAllButton: true,
    hideLastPostSm: false,
  }

  render() {
    let {
      topic,
      posts,
      className,
      showAllButton,
      showTopics,
      hideLastPostSm,
      teaserText,
    } = this.props
    return (
      <div
        key={'topic-container-' + topic}
        className={classNames(css.topicContainer, 'clearfix pbxl mbxl')}
      >
        <StyledSubHeading className={classNames(css.topicHeader, 'h3 mbm mtn')}>
          {topic.name}
        </StyledSubHeading>
        {teaserText && <div className="mbl">{teaserText}</div>}
        <PostCard
          cardSize={'medium'}
          title={posts[0].title}
          image={posts[0].featuredImage.url}
          teaserText={posts[0].teaser}
          slug={posts[0].slug}
        />
        <div className="clearfix">
          <PostCardRow
            showTopics={showTopics}
            hideLastPostSm={hideLastPostSm}
            posts={posts.slice(1, posts.length)}
            numColumns={3}
            className="mtxl"
          />
        </div>
        {showAllButton ? (
          <div className="text-center">
            <Link
              className={classNames(
                css.viewAllButton,
                'btn-empty btn btn-info'
              )}
              to={helloBabyPostPath(topic.slug)}
            >
              {topic.slug === 'sample-registries'
                ? 'View all sample registries'
                : 'View all in ' + topic.name}
            </Link>
          </div>
        ) : null}
      </div>
    )
  }
}

TopicSection.propTypes = {
  topic: PropTypes.object.isRequired,
  posts: PropTypes.array.isRequired,
  className: PropTypes.string,
  showAllButton: PropTypes.bool,
  showTopic: PropTypes.bool,
  hideLastPostSm: PropTypes.bool,
  teaserText: PropTypes.string,
}

export default TopicSection
